import React, { useState, useRef, useEffect } from "react";

// react-bootstrap components
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  InputGroup,
  Modal,
  Row,
  Tab,
  Tabs,
} from "react-bootstrap";
import Select from "react-select";
// core components
import ReactTable from "components/ReactTable/ReactTable.js";
import { Query, useMutation } from "react-apollo";
import { GET_CLIENT } from "./queries";

import map from "lodash/map";
import find from "lodash/find";
import unset from "lodash/unset";
import head from "lodash/head";
import set from "lodash/set";
import cloneDeep from "lodash/cloneDeep";
import concat from "lodash/concat";
import includes from "lodash/includes";
import withSession from "./withSession";
import {
  ADD_CHALLENGE_TO_CLIENT,
  UPDATE_CHALLENGE,
  DELETE_CHALLENGE,
  IMAGE_UPLOAD,
  PUBLISH_CHALLENGE,
  SEND_NOTIFICATIONS,
  ADD_NOTIFICATION_TO_CLIENT,
  UPDATE_NOTIFICATION,
  DELETE_NOTIFICATION,
  SEND_SYSTEM_MESSAGES,
} from "./mutations";
import Dropzone from "react-dropzone";
import ReactQuill from "react-quill";
import { modules } from "constants/reactQuill";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { v4 as uuidv4 } from "uuid";

import "./Forms/SignUpWizard/datePicker.css";

function Messages(props) {
  const [modal, setModal] = React.useState(false);
  const [message, setMessage] = React.useState("");
  const textareaRef = useRef(null);

  const handleClose = () => {
    setModal(false);
    setMessage("");
  };

  const [sendSystemMessage] = useMutation(SEND_SYSTEM_MESSAGES);

  const handleSend = () => {
    sendSystemMessage({
      variables: {
        members: map(props.selected || [], (user) => user?.original?._id),
        messages: [
          {
            _id: uuidv4(),
            text: message,
            user: {
              _id: "SYSTEM ADMIN",
              name: "Admin",
            },
            createdAt: new Date(),
          },
        ],
      },
    }).then(() => {
      handleClose();
    });
  };

  // Auto-resize textarea as content grows
  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height =
        textareaRef.current.scrollHeight + "px";
    }
  }, [message]);

  return (
    <>
      <Button
        onClick={() => setModal(!modal)}
        style={{
          paddingLeft: 20,
          paddingRight: 20,
          paddingTop: 15,
          paddingBottom: 15,
          fontSize: 16,
          fontWeight: "bold",
        }}
      >
        Send Message
      </Button>
      <Modal
        className="modal-primary"
        onHide={handleClose}
        show={modal}
        size="md"
      >
        <Modal.Header className="justify-content-center">
          <label>Send Message</label>
        </Modal.Header>
        <Modal.Body>
          <Form action="#" method="#">
            <Form.Group>
              <label>Message</label>
              <Form.Control
                ref={textareaRef}
                value={message}
                placeholder="Message"
                as="textarea"
                rows={4}
                style={{ overflow: "hidden", resize: "none" }}
                onChange={(event) => setMessage(event.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <div className="modal-footer">
          <Button className="btn-simple" onClick={handleClose} variant="link">
            Cancel
          </Button>
          <Button
            className="btn-simple"
            onClick={handleSend}
            variant="outlined"
            color="primary"
            disabled={!message}
          >
            Send Now
          </Button>
        </div>
      </Modal>
    </>
  );
}

export default withSession(Messages);
